import { ActionType, ActionTypes, State } from './types';

const initialState = {
  isLoading: false,
  error: '',
  data: undefined,
};

const legacyUserReducer = (state: State = initialState, action: ActionType): State => {
  switch (action.type) {
    case ActionTypes.FETCH_USER_START:
      return {
        ...state,
        isLoading: true,
      };
    case ActionTypes.FETCH_USER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.payload,
      };
    case ActionTypes.FETCH_USER_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    case ActionTypes.CLEAN_USER:
      return initialState;
    default:
      return state;
  }
};

export default legacyUserReducer;
